import React from "react"

const getTextFromNode = (node: React.ReactNode): string => {
  if (typeof node === "string") {
    // Проверяем, есть ли тег h1 в строке, если строка приходит из сео админки
    const h1Match = node.match(/<h1.*?>(.*?)<\/h1>/i)
    if (h1Match) {
      return h1Match[1].replace(/<[^>]*>/g, " ").trim()
    }

    // Если h1 нет, возвращаем всю строку, очищенную от HTML-тегов и &nbsp
    return node
      .replace(/&nbsp;|\u00A0/g, " ")
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim()
  }

  if (typeof node === "number") {
    return node.toString()
  }

  if (React.isValidElement(node)) {
    if (node.type === "br") {
      return " "
    }
    return React.Children.toArray(node.props.children)
      .map(getTextFromNode)
      .join(" ")
      .replace(/\s+/g, " ")
  }

  return ""
}

export default getTextFromNode
